import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bold" }, "Переменные", -1)
const _hoisted_2 = { class: "mt-2 mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Расположение функционала "),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "\"Боты\" - \"Ваш бот\" - \"Переменные\"")
], -1)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<p class=\"mt-3 mb-1\"><span class=\"fw-bold\">Переменные</span> - это контейнеры в которых хранятся данные, у переменной есть следующие характеристики: </p><ul class=\"ms-3\"><li><span class=\"fw-bold\">Название</span> - просто название для более удобной работы с переменной</li><li><span class=\"fw-bold\">Код</span> - используется при подстановке переменной в сообщении или при передаче в HTTP запросах</li><li><span class=\"fw-bold\">Значение</span> - собственно само значение хранимое в переменной</li><li><span class=\"fw-bold\">Тип данных</span> - числовой, строковый</li><li><span class=\"fw-bold\">Тип</span> - глобальная или персональная</li></ul><p> При добавлении бота в конструктор, автоматически создаются некоторые переменные которые называются системными, например: <span class=\"fw-bold\">_user_link_to_profile</span>, <span class=\"fw-bold\">_bot_name</span>, <span class=\"fw-bold\">_current_datetime</span> и т.д. Их значения контролирует конструктор, нет возможности поменять их значение из сценария, триггеров и т.д. Переменные создаваемые автором бота называются пользовательскими. </p><p> Так же переменные делятся по типу на глобальные или персональные. Отличие в том в рамках чего просходит хранение значения переменной, если у каждого пользователя бота значение переменной может быть своим (например - количество заказов этого пользователя), то это персональная переменная. Если же значение распространяется на всех пользователей бота, то это глобальная переменная - например глобальный счетчик заказов всех клиентов. </p>", 4)
const _hoisted_8 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpInfo = _resolveComponent("HelpInfo")!
  const _component_Image = _resolveComponent("Image")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_HelpInfo, null, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Image, {
          class: "d-flex justify-content-center",
          src: "/docs_context.png",
          preview: "",
          "image-style": {
              display: 'block',
              height: '200px',
              maxWidth: '100%',
          }
        })
      ])
    ])
  ]))
}